<template>
    <nav class="bg-white shadow" :class="config.env">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center flex-wrap py-3">
                <div class="col-12 col-sm-4 text-center text-sm-start mb-4 mb-sm-0">
                    <a href="https://autoguidovie.it/">
                        <img :src="require(`@/assets/img/tenants/${omsApiKey}.png`)" class="w-50" alt="AUTOGUIDOVIE">
                    </a>
                </div>
                <div class="col-12 col-sm-4 text-center mb-2 mb-sm-0">
                    <span class="badge bg-second rounded">
                        <i class="fa-solid fa-globe"></i>
                        {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
                        <i class="fa-solid fa-globe"></i>
                    </span>
                </div>
                <div class="col-12 col-sm-4 d-flex justify-content-center justify-content-sm-end align-items-center flex-wrap">
                    <span data-bs-toggle="dropdown" class="text-nowrap me-2" role="button">
                        {{ account.name }} {{ account.surname }}
                    </span>
                    <i class="fa-regular fa-circle-user text-second fs-4" data-bs-toggle="dropdown"></i>
                    <ul class="dropdown-menu dropdown-menu-end dropdowns">
                        <li>
                            <router-link class="dropdown-item text-center" to="/dashboard">
                                {{ $t('Navbar.dropdown.Dashboard') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link class="dropdown-item text-center" to="/dashboard/account">
                                {{ $t('Navbar.dropdown.Account') }}
                            </router-link>
                        </li>
                        <li>
                            <span class="dropdown-item text-center" @click="this.$store.dispatch('logout')">
                                {{ $t('Navbar.dropdown.logout') }}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    name: 'NavbarComp',
    computed: {
        ...mapState(['config', 'account']),
        ...mapGetters(['omsApiKey'])
    }
}
</script>